/**
 * Initialize Swiper sliders for the Participants Slider flex component
 */

/* global Swiper, jQuery */

jQuery(document).ready(function ($) {
  if (!$('.participants-slider').length) {
    return;
  }

  $('.participants-slider').each(function (index) {
    const $slider = $(this);
    const $outerContainer = $slider.closest('.participants-slider-outer-container');
    const sliderId = `participants-slider-${index}`;
    const outerContainerId = `participants-slider-outer-${index}`;

    if (!$outerContainer.length) {
      return;
    }

    $slider.attr('id', sliderId);
    $outerContainer.attr('id', outerContainerId);
    $slider.addClass('swiper');

    // Function to update slide info
    function updateSlideInfo(swiperInstance) {
      const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);
      const slideId = $activeSlide.data('slide-id');

      const $contentBlock = $outerContainer.find(`.slide-data[data-slide-id="${slideId}"]`);
      const $slideInfo = $outerContainer.find('.slider-info');

      if ($contentBlock.length && $slideInfo.length) {
        // Fade out effect
        $slideInfo.fadeOut(200, function () {
          $slideInfo.html($contentBlock.html()).fadeIn(200);
        });
      }
    }

    // Stop any playing video on slides other than the active one
    function stopInactiveVideos(swiperInstance) {
      swiperInstance.slides.forEach(function (slideEl, i) {
        if (i === swiperInstance.activeIndex) {
          return;
        }

        const $slide = $(slideEl);
        $slide.find('.video-embed iframe').each(function () {
          this.src = this.src.replace(/([?&])autoplay=1&?/, '$1').replace(/[?&]$/, '');
        });

        // YouTube (lite-youtube-embed): drop back to its unplayed poster state.
        $slide.find('lite-youtube.lyt-activated').each(function () {
          $(this).removeClass('lyt-activated').find('iframe').remove();
        });

        // Reset the click-to-play cover image so it reappears next time.
        $slide.find('.video.has-cover-image.playing').removeClass('playing');
      });
    }

    // Initialize Swiper with navigation
    // slidesPerView 1: only the active slide is ever visible, no neighbor peek
    new Swiper(`#${sliderId}`, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // Swiper navigation
      navigation: {
        nextEl: `#${outerContainerId} .slider-next`,
        prevEl: `#${outerContainerId} .slider-prev`,
      },
      on: {
        slideChange: function () {
          updateSlideInfo(this);
          stopInactiveVideos(this);
        },
        init: function () {
          updateSlideInfo(this);
        },
      },
    });
  });
});
